
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
const app = namespace("app");
@Component({})
export default class Footer extends Vue {
  @app.State btnLoading;
  @Prop({ default: false, type: Boolean })
  hideLeft: boolean;
  @Prop({ default: () => t("base.back") })
  leftText: string;
  @Prop({ default: () => t("base.done") })
  rightText: string;

  footerLeft() {
    this.$router.go(-1);
  }
  footerRight() {
    this.$emit("footerRight");
  }
}
